import { render, staticRenderFns } from "./TenancyUsers.vue?vue&type=template&id=32e251ae&scoped=true&"
import script from "./TenancyUsers.vue?vue&type=script&lang=js&"
export * from "./TenancyUsers.vue?vue&type=script&lang=js&"
import style0 from "./TenancyUsers.vue?vue&type=style&index=0&id=32e251ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e251ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e251ae')) {
      api.createRecord('32e251ae', component.options)
    } else {
      api.reload('32e251ae', component.options)
    }
    module.hot.accept("./TenancyUsers.vue?vue&type=template&id=32e251ae&scoped=true&", function () {
      api.rerender('32e251ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/tenants/TenancyUsers.vue"
export default component.exports